export default "__VITE_PUBLIC_ASSET__c92a7871__"